function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import browserUpdate from "browser-update";
import { SnackbarProvider } from "notistack";
import React, { Component, lazy, Suspense } from "react";
import { castArray, isEmpty, isEqual, omit } from "lodash";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { setTokenObject } from "@common/services/helpers";
import { changeScreenType, closeGdpr, closeModal, closePromotions, closeSnackbar, closeWriteToUs, getAppConfig, getFullUserDetails, getLiveCategories, getLiveChannels, getLogos, getProfileSettings, getServerTime, getTranslations, getUserDetails, getUserMessages, openModal, openPromotions, openSnackbar, prismicGetSubscriptions, setAuthToken, setLastRequestedRoute, setLiveChannelsLayout, setVideoToPlayAfterSubscription, toggleHeader, toggleVideoPlayerState } from "@common/actions";
import { addSwipeEvent, isMobile } from "@common/services/helpers";
import { isBillingValid } from "@common/utils/helpers";
import { ACCOUNT, BROWSER_UPDATE_NOTIFIER_OPTIONS, CATEGORIES_ALL_ID, COOKIE_POLICY, DEFAULT_LOGGED_ROUTE, DELETE_ACCOUNT, DELETE_ACCOUNT_IS_FORM, DIRECTION_DOWN, DIRECTION_UP, INSTALLATION_GUIDE, KEY_TAB, LARGE_MOBILE_TYPE_PX, LAST_REQUESTED_ROUTE_IGNORE_LIST, MESSAGE_MODULE, MISSING_INFO, MOBILE_TYPE_PX, MOST_WATCHED, NOTIFICATION_REMINDER_TIME, ROUTE_ACCOUNT, ROUTE_ACCOUNT_DELETE, ROUTE_ARCHIVE, ROUTE_CATEGORY, ROUTE_LIVE, ROUTE_ON_RECORD, ROUTE_ORDER, ROUTE_ORDER_ADDRESSES, ROUTE_ORDER_PREVIEW, ROUTE_ORDER_SUBSCRIPTIONS, ROUTE_SEARCH, ROUTE_TOO_MANY_USERS, SMALL_MOBILE_TYPE_PX, SUBSCRIPTION_ACTIVE, SUBSCRIPTION_NON_RENEWING, SUBSCRIPTION_PLAN_BASIC, SUBSCRIPTION_PLAN_PREMIUM, SUBSCRIPTION_PLAN_STANDART, TABLET_TYPE_PX, VOD } from "@config/constants";
import Confirmation from "@common/components/Confirmation";
import CookieBanner from "@common/components/CookieBanner";
import DownloadAppBanner from "@common/components/DownloadAppBanner";
import Gdpr from "@common/components/Gdpr";
import Header from "@common/components/Header";
import Notifications from "@common/components/Notifications";
import ModalConductor from "@common/components/modals/ModalConductor";
// Components
import ChannelHistory from "@common/containers/ChannelHistory";
import ChannelListingForDate from "@common/containers/ChannelListingForDate";
import ForgottenPasswordRequestPage from "@common/containers/ForgottenPasswordRequestPage";
import NoMatch from "@common/containers/NoMatch";
var Live = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/Live");
});
var LastWatchedCategories = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/last-watched/LastWatchedCategories");
});
var LastWatchedCategoryListing = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/last-watched/LastWatchedCategoryListing");
});
var LastWatchedSubcategories = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/last-watched/LastWatchedSubcategories");
});
var LastWatchedSubcategoryListing = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/last-watched/LastWatchedSubcategoryListing");
});
var MostWatchedCategories = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/most-watched/MostWatchedCategories");
});
var MostWatchedCategoryListing = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/most-watched/MostWatchedCategoryListing");
});
var MostWatchedSubcategories = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/most-watched/MostWatchedSubcategories");
});
var MostWatchedSubcategoryListing = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/most-watched/MostWatchedSubcategoryListing");
});
var OnRecordCategories = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/on-record/OnRecordCategories");
});
var VODCategories = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/vod/VODCategories");
});
var VODSubcategories = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/vod/VODSubcategories");
});
var VODCategoryListing = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/vod/VODCategoryListing");
});
var VODSubcategoryListing = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/vod/VODSubcategoryListing");
});
var OnRecordCategoryListing = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/on-record/OnRecordSubcategories");
});
var OnRecordSubcategories = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/on-record/OnRecordSubcategories");
});
var OnRecordSubcategoryListing = /*#__PURE__*/ lazy(function() {
    return import("@common/containers/on-record/OnRecordSubategoryListing");
});
// TODO: switch to @common/containers when updating telekabel shopping cart
var Order = /*#__PURE__*/ lazy(function() {
    return import("@containers/Order");
});
import PinModal from "@common/components/PinModal";
import Promotions from "@common/components/Promotions";
import WriteToUs from "@common/components/WriteToUs";
import PlayerWrapper from "@common/components/player/PlayerWrapper";
import PrivaciPolicyPage from "@common/containers/PrivacyPolicyPage";
import ResetPasswordPage from "@common/containers/ResetPasswordPage";
import RestrictedGeography from "@common/containers/RestrictedGeography";
import ScrollToTop from "@common/containers/ScrollToTop";
import SearchPage from "@common/containers/SearchPage";
import SignInPage from "@common/containers/SignInPage";
import SignUpPage from "@common/containers/SignUpPage";
import TermsAndConditionsPage from "@common/containers/TermsAndConditionsPage";
import TooManyUsers from "@common/containers/TooManyUsers";
import DeleteAccountPage from "@common/containers/account/DeleteAccountPage";
import GuidePage from "./GuidePage";
var App = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(App, Component);
    var _super = _create_super(App);
    function App(props) {
        _class_call_check(this, App);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "queuePostLoginAction", function(action1) {
            var postLoginActions = Array.isArray(_this.state.postLoginActions) ? _to_consumable_array(_this.state.postLoginActions).concat([
                action1
            ]) : [
                action1
            ];
            _this.setState({
                postLoginActions: postLoginActions
            });
        });
        _define_property(_assert_this_initialized(_this), "handleAccountRoute", function() {
            var _this_props = _this.props, history = _this_props.history, location = _this_props.location, _$openModal = _this_props.openModal;
            var authentication = _this.props.state.authentication;
            var matchRoute = function(route) {
                return location.pathname.search(route) >= 0;
            };
            if (!matchRoute(ROUTE_ACCOUNT)) return;
            // Potentially add more routes here
            if (matchRoute(ROUTE_ACCOUNT_DELETE) && !DELETE_ACCOUNT_IS_FORM) {
                var wasLoggedIn = authentication.token;
                if (wasLoggedIn) {
                    var _history_location_state;
                    history.replace(((_history_location_state = history.location.state) === null || _history_location_state === void 0 ? void 0 : _history_location_state.from) || "/");
                }
                var searchParams = new URLSearchParams(location.search);
                var email = searchParams.get("email");
                _this.queuePostLoginAction(function() {
                    if (_this.props.state.userDetails.email !== email && wasLoggedIn) return;
                    _$openModal(ACCOUNT, {
                        initialComponent: DELETE_ACCOUNT,
                        email: email
                    });
                });
            }
        });
        _define_property(_assert_this_initialized(_this), "handleFreeSubscriptionPromoBanner", function(userDetails) {
            var planDetails = userDetails.planDetails;
            if (!isEmpty(planDetails) && planDetails.isBasic) {
                _this.setState({
                    shouldShowPromotions: false
                }, function() {
                    _this.props.openPromotions();
                });
            }
        });
        _define_property(_assert_this_initialized(_this), "handlePromoBanner", function(userDetails, prismicContent) {
            var plans_items = prismicContent.plans_items;
            var subscription = userDetails.subscription, email = userDetails.email;
            if (isEmpty(plans_items) || isEmpty(subscription)) return;
            var plan = castArray(plans_items).find(function(plan) {
                return plan.id === subscription[0].planId;
            });
            if (!plan) {
                _this.handleFreeSubscriptionPromoBanner(userDetails);
                return;
            }
            var promo_display = plan.promo_display;
            var localstorageKeyName = "hidePaidPromotion";
            if (promo_display !== "One-Time") {
                localStorage.removeItem(localstorageKeyName);
            }
            switch(promo_display){
                case "One-Time":
                    {
                        var hidePaidPromotionString = localStorage.getItem(localstorageKeyName);
                        var hidePaidPromotion = !isEmpty(hidePaidPromotionString) && JSON.parse(hidePaidPromotionString);
                        if (!(hidePaidPromotion === null || hidePaidPromotion === void 0 ? void 0 : hidePaidPromotion.shown)) {
                            localStorage.removeItem(localstorageKeyName);
                            _this.setState({
                                shouldShowPromotions: false
                            }, function() {
                                localStorage.setItem(localstorageKeyName, JSON.stringify({
                                    shown: true
                                }));
                                _this.props.openPromotions(plan);
                            });
                        }
                        break;
                    }
                case "On Login":
                    {
                        if (_this.state.newUserLogin) {
                            _this.setState({
                                shouldShowPromotions: false
                            }, function() {
                                _this.props.openPromotions(plan);
                            });
                        }
                        break;
                    }
                case "Never":
                    break;
                default:
                    _this.setState({
                        shouldShowPromotions: false
                    });
                    break;
            }
        });
        _this.state = {
            headerWheelEventIsSet: false,
            playerWheelEventIsSet: false,
            routerContainerWheelEventIsSet: false,
            showCommonElements: true,
            showExpiringSubscriptionNotification: false,
            shouldShowCookieBanner: false,
            isScreenLandscape: false,
            isMobileOnLandscape: false,
            shouldShowPromotions: true,
            liveChannelsTimeStamp: CATEGORIES_ALL_ID,
            isCategoriesFilterOpen: false,
            isAlphabeticalFilterChecked: false,
            firstChannelRef: null,
            prismicContent: null,
            appBannerOpen: true,
            missingInfoModalQueued: false,
            messageModuleQueued: false,
            messages: null,
            postLoginModalOpened: false,
            forceShowMissingInfo: false
        };
        _this.handleScroll = _this.handleScroll.bind(_assert_this_initialized(_this));
        _this.handleWheelRouter = _this.handleWheelRouter.bind(_assert_this_initialized(_this));
        _this.handleSwipe = _this.handleSwipe.bind(_assert_this_initialized(_this));
        _this.openPlayer = _this.openPlayer.bind(_assert_this_initialized(_this));
        _this.closePlayer = _this.closePlayer.bind(_assert_this_initialized(_this));
        _this.handleWindowResize = _this.handleWindowResize.bind(_assert_this_initialized(_this));
        _this.closeCookieBanner = _this.closeCookieBanner.bind(_assert_this_initialized(_this));
        _this.detectTabKeyPress = _this.detectTabKeyPress.bind(_assert_this_initialized(_this));
        _this.detectClick = _this.detectClick.bind(_assert_this_initialized(_this));
        _this.setMenuFlag = _this.setMenuFlag.bind(_assert_this_initialized(_this));
        _this.closeModalOnBackButton = _this.closeModalOnBackButton.bind(_assert_this_initialized(_this));
        _this.getLiveChannels = _this.getLiveChannels.bind(_assert_this_initialized(_this));
        _this.onAlphabeticalFilterChange = _this.onAlphabeticalFilterChange.bind(_assert_this_initialized(_this));
        _this.toggleCategoryFilter = _this.toggleCategoryFilter.bind(_assert_this_initialized(_this));
        _this.closeCategoryFilter = _this.closeCategoryFilter.bind(_assert_this_initialized(_this));
        _this.snackbarAction = _this.snackbarAction.bind(_assert_this_initialized(_this));
        _this.onAppBannerChange = _this.onAppBannerChange.bind(_assert_this_initialized(_this));
        _this.setPostLoginModalOpened = _this.setPostLoginModalOpened.bind(_assert_this_initialized(_this));
        _this.getQueryParam = _this.getQueryParam.bind(_assert_this_initialized(_this));
        _this.routerContainer = null;
        _this.header = null;
        _this.player = null;
        _this.swipeEvents = null;
        _this.isMenuOpened = false;
        _this.messageIntervalId = null;
        return _this;
    }
    _create_class(App, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var authToken;
                    return _ts_generator(this, function(_state) {
                        _this.props.getAppConfig();
                        _this.handleAccountRoute();
                        browserUpdate(BROWSER_UPDATE_NOTIFIER_OPTIONS);
                        window.addEventListener("popstate", _this.closeModalOnBackButton);
                        if (isMobile.any()) {
                            document.getElementById("body").classList.add("mobile-device");
                        } else {
                            _this.swipeEvents = addSwipeEvent(_this.handleSwipe);
                            window.addEventListener("touchstart", _this.swipeEvents.touchStart, false);
                            window.addEventListener("touchend", _this.swipeEvents.touchEnd, false);
                            document.addEventListener("keydown", _this.detectTabKeyPress, false);
                            document.addEventListener("click", _this.detectClick, false);
                        }
                        authToken = _this.getQueryParam("authToken");
                        if (authToken) {
                            _this.props.setAuthToken(authToken);
                            setTokenObject({
                                access_token: authToken
                            });
                        }
                        _this.props.getTranslations();
                        _this.handleWindowResize();
                        window.addEventListener("resize", _this.handleWindowResize, false);
                        _this.props.getLogos();
                        _this.props.getUserMessages();
                        _this.props.getFullUserDetails();
                        _this.props.getUserDetails();
                        _this.props.getLiveCategories();
                        _this.props.getProfileSettings();
                        _this.props.getServerTime();
                        _this.messageIntervalId = setInterval(_this.props.getUserMessages, 1000 * 60 * 60);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps, nextState) {
                var _this_props_state_prismic, _this_props_state, _nextProps_state_userDetails_subscription_, _nextProps_state_userDetails_subscription;
                var prevToken = this.props.state.authentication.token;
                var nextToken = nextProps.state.authentication.token;
                var _nextProps_state = nextProps.state, userDetails = _nextProps_state.userDetails, modal = _nextProps_state.modal;
                var email = userDetails.email, _userDetails_planDetails = userDetails.planDetails, planDetails = _userDetails_planDetails === void 0 ? {} : _userDetails_planDetails;
                var prismicContent = (_this_props_state = this.props.state) === null || _this_props_state === void 0 ? void 0 : (_this_props_state_prismic = _this_props_state.prismic) === null || _this_props_state_prismic === void 0 ? void 0 : _this_props_state_prismic.subscriptions;
                if (nextToken && prevToken !== nextToken) {
                    this.setState({
                        newUserLogin: true
                    });
                    this.props.getLogos();
                    this.props.getFullUserDetails();
                    this.props.getUserDetails();
                    this.props.getUserMessages();
                    this.props.getLiveCategories();
                    this.props.getProfileSettings();
                }
                if (!isEmpty(userDetails) && nextToken && this.state.shouldShowPromotions && !isEmpty(prismicContent)) {
                    this.handlePromoBanner(userDetails, prismicContent);
                }
                // Keep track on the last visited route.
                // This will be used when the user tries
                // to navigate to a page that is protected and
                // he/she is not signed in. So a redirection to
                // '/login' will occur and the prevPath
                // (the target page) will be the one to redirect
                // after signing in.
                var prevPath = this.props.location.pathname;
                var nextPath = nextProps.location.pathname;
                if (nextPath.search(ROUTE_ORDER) >= 0 && this.state.showCommonElements) {
                    this.setState({
                        showCommonElements: false
                    });
                } else if (nextPath.search(ROUTE_ORDER) < 0 && !this.state.showCommonElements) {
                    this.setState({
                        showCommonElements: true
                    });
                }
                // Set object with video options to play
                // after visiting subscription page
                var videoPlayer = this.props.state.videoPlayer;
                if (prevPath !== ROUTE_ORDER_SUBSCRIPTIONS && nextPath === ROUTE_ORDER_SUBSCRIPTIONS && videoPlayer.isPlaying) {
                    this.props.setVideoToPlayAfterSubscription({
                        isOpen: videoPlayer.isOpen,
                        isPlaying: true,
                        channelId: videoPlayer.channelId,
                        video: {
                            start: videoPlayer.video.start,
                            stop: videoPlayer.video.stop,
                            startPosition: 0
                        }
                    });
                }
                // The second boolean prevents the app
                // to enter in infinite redirect loop (after login)
                // from route that shouldn't open when user is logged
                // to '/login' and again to the corresponding route.
                if (prevPath !== nextPath && LAST_REQUESTED_ROUTE_IGNORE_LIST.indexOf(prevPath) < 0) {
                    this.props.setLastRequestedRoute(prevPath);
                }
                // When reference changes, navigate to the restricted access page.
                if (this.props.state.errors.tooManyUsers !== nextProps.state.errors.tooManyUsers) {
                    this.props.history.push(ROUTE_TOO_MANY_USERS);
                }
                if (this.props.state && !isMobile.any()) {
                    if (this.routerContainer && !this.state.routerContainerWheelEventIsSet) {
                        this.setState({
                            routerContainerWheelEventIsSet: true
                        });
                        this.routerContainer.addEventListener("wheel", this.handleWheelRouter);
                    }
                    if (this.header && !this.state.headerWheelEventIsSet) {
                        this.setState({
                            headerWheelEventIsSet: true
                        });
                        this.header.addEventListener("wheel", this.handleScroll);
                    }
                    if (this.player && !this.state.playerWheelEventIsSet) {
                        this.setState({
                            playerWheelEventIsSet: true
                        });
                        this.player.addEventListener("wheel", this.handleScroll);
                    }
                }
                if (email) {
                    var cookieConsent = localStorage.getItem("".concat(email, "-cookieConsent"));
                    if (!cookieConsent && (nextPath === ROUTE_ON_RECORD || nextPath === ROUTE_LIVE || nextPath === MOST_WATCHED)) {
                        this.setState({
                            shouldShowCookieBanner: true
                        });
                    } else {
                        this.setState({
                            shouldShowCookieBanner: false
                        });
                    }
                }
                var date = Date.now();
                var reminderStartTime = localStorage.getItem("".concat(email, "-reminderStartTime"));
                var reminderTime = (date - reminderStartTime) / (60 * 60 * 1000);
                if (reminderTime > NOTIFICATION_REMINDER_TIME) {
                    if (typeof localStorage !== "undefined") {
                        localStorage.removeItem("".concat(email, "-reminderStartTime"));
                    } else {
                        console.error("localStorage is not available in this browser context");
                    }
                }
                if (((_nextProps_state_userDetails_subscription = nextProps.state.userDetails.subscription) === null || _nextProps_state_userDetails_subscription === void 0 ? void 0 : (_nextProps_state_userDetails_subscription_ = _nextProps_state_userDetails_subscription[0]) === null || _nextProps_state_userDetails_subscription_ === void 0 ? void 0 : _nextProps_state_userDetails_subscription_.status) === SUBSCRIPTION_NON_RENEWING && nextPath.search(ROUTE_ORDER) < 0) {
                    var daysBeforeSubscriptionEnd = (nextProps.state.userDetails.subscription[0].currentTermEnd - date / 1000) / (24 * 60 * 60);
                    if (daysBeforeSubscriptionEnd <= 7) {
                        this.setState({
                            showExpiringSubscriptionNotification: true
                        });
                    }
                } else this.setState({
                    showExpiringSubscriptionNotification: false
                });
                var modalOverlay = document.getElementsByClassName("modal-overlay")[0];
                if (modalOverlay) {
                    if (isMobile.any() && (modal.isConfirmationOpened || modal.isGdprOpened)) {
                        modalOverlay.classList.add("opened-confirmation");
                    } else {
                        modalOverlay.classList.remove("opened-confirmation");
                    }
                }
                if (isMobile.any()) {
                    if (this.routerContainer) {
                        if (window.innerWidth <= TABLET_TYPE_PX && (modal.isModalOpened || modal.isPromotionsOpened || modal.isWriteToUsOpened)) {
                            this.routerContainer.classList.add("modal-open");
                        } else {
                            this.routerContainer.classList.remove("modal-open");
                        }
                    }
                }
            }
        },
        {
            key: "showNotification",
            value: function showNotification() {
                var userDetails = this.props.state.userDetails;
                var location = this.props.location;
                var paymentMethod = userDetails.paymentMethod, billingAddress = userDetails.billingAddress, subscription = userDetails.subscription, planDetails = userDetails.planDetails;
                if (isEmpty(subscription)) return null;
                if (!(planDetails === null || planDetails === void 0 ? void 0 : planDetails.isPaid)) return null;
                if (location.pathname !== ROUTE_ORDER && subscription[0].status === SUBSCRIPTION_NON_RENEWING && (planDetails === null || planDetails === void 0 ? void 0 : planDetails.isBasic) === false) {
                    var date = Date.now();
                    var daysBeforeSubscriptionEnd = (subscription[0].currentTermEnd - date / 1000) / (24 * 60 * 60);
                    if (daysBeforeSubscriptionEnd <= 10) {
                        return /*#__PURE__*/ _jsx(Notifications, {
                            notifType: "Shopping cart"
                        });
                    }
                }
                if ((isEmpty(paymentMethod) || !isBillingValid(billingAddress)) && (planDetails === null || planDetails === void 0 ? void 0 : planDetails.isBasic) === false) {
                    return /*#__PURE__*/ _jsx(Notifications, {
                        notifType: "Missing info"
                    });
                }
                return null;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this = this;
                var _prevProps_state;
                var _this_props_state = this.props.state, userDetails = _this_props_state.userDetails, authentication = _this_props_state.authentication;
                var prevUserDetails = prevProps === null || prevProps === void 0 ? void 0 : (_prevProps_state = prevProps.state) === null || _prevProps_state === void 0 ? void 0 : _prevProps_state.userDetails;
                var _this_props = this.props, history = _this_props.history, location = _this_props.location;
                // Get full user details if the user is logged in
                // or if the user changes the account
                if (!isEmpty(userDetails) && ((prevUserDetails === null || prevUserDetails === void 0 ? void 0 : prevUserDetails.email) !== (userDetails === null || userDetails === void 0 ? void 0 : userDetails.email) || !isEqual(prevUserDetails === null || prevUserDetails === void 0 ? void 0 : prevUserDetails.subscription, userDetails === null || userDetails === void 0 ? void 0 : userDetails.subscription))) {
                    this.props.getFullUserDetails().then(function() {
                        return _this.props.prismicGetSubscriptions();
                    });
                }
                //
                var tosPath = "/terms-of-use";
                if (userDetails.cf_terms === false && location.pathname !== tosPath && authentication.token) {
                    history.push(tosPath);
                }
                if (this.props.location.pathname !== prevProps.location.pathname) {
                    this.setState({
                        prevLocation: prevProps.location.pathname
                    });
                    this.handleAccountRoute();
                }
                var postponed = sessionStorage.getItem("missing-info");
                var paymentMethod = userDetails.paymentMethod, billingAddress = userDetails.billingAddress, subscription = userDetails.subscription, planDetails = userDetails.planDetails;
                if (!postponed && !isEmpty(subscription) && (isEmpty(paymentMethod) || !isBillingValid(billingAddress)) && (planDetails === null || planDetails === void 0 ? void 0 : planDetails.isBasic) === false && (planDetails === null || planDetails === void 0 ? void 0 : planDetails.isPaid)) {
                    var _subscription_;
                    var date = Date.now();
                    var daysBeforeSubscriptionEnd = (subscription[0].currentTermEnd - date / 1000) / (24 * 60 * 60);
                    if (daysBeforeSubscriptionEnd <= 5 && !this.state.forceShowMissingInfo && userDetails.cf_terms !== false && ((_subscription_ = subscription[0]) === null || _subscription_ === void 0 ? void 0 : _subscription_.status) === SUBSCRIPTION_ACTIVE) {
                        this.setState({
                            forceShowMissingInfo: true
                        });
                    }
                }
                var userMessages = this.props.state.userMessages;
                if (this.shouldRenderMessage()) {
                    this.renderMessagePopup();
                } else if (this.shouldRenderMissingInfo()) {
                    this.renderMissingInfo();
                } else if (this.shouldRenderGuide()) {
                    this.renderGuide();
                }
                // Check if we have full user details
                if (!isEmpty(userDetails === null || userDetails === void 0 ? void 0 : userDetails.email) && !isEmpty(this.state.postLoginActions)) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this.state.postLoginActions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            action = _step.value;
                            action();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this.setState({
                        postLoginActions: null
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("resize", this.handleWindowResize, false);
                window.removeEventListener("popstate", this.closeModalOnBackButton);
                if (this.messageIntervalId) clearInterval(this.messageIntervalId);
                if (!isMobile.any()) {
                    window.removeEventListener("touchstart", this.swipeEvents.touchStart, false);
                    window.removeEventListener("touchend", this.swipeEvents.touchEnd, false);
                    document.removeEventListener("keydown", this.detectTabKeyPress, false);
                    document.removeEventListener("click", this.detectClick, false);
                    if (this.routerContainer) {
                        this.routerContainer.removeEventListener("wheel", this.handleWheelRouter);
                    }
                    if (this.header) {
                        this.header.removeEventListener("wheel", this.handleScroll);
                    }
                    if (this.player) {
                        this.player.removeEventListener("wheel", this.handleScroll);
                    }
                }
            }
        },
        {
            /**
     * Toggles the list with categories.
     */ key: "toggleCategoryFilter",
            value: function toggleCategoryFilter() {
                this.setState(function(prevState) {
                    return {
                        isCategoriesFilterOpen: !prevState.isCategoriesFilterOpen
                    };
                });
            }
        },
        {
            /**
     * Closes the categories filter menu
     */ key: "closeCategoryFilter",
            value: function closeCategoryFilter() {
                this.setState({
                    isCategoriesFilterOpen: false
                });
            }
        },
        {
            /**
     * Closes modal on back button press
     */ key: "closeModalOnBackButton",
            value: function closeModalOnBackButton() {
                this.props.closeModal();
                this.props.closeGdpr();
                this.props.closePromotions();
                this.props.closeWriteToUs();
            }
        },
        {
            /**
     * Detect tab key press and sets a class on the body to allow focus highlighting
     * @param event {Object}
     */ key: "detectTabKeyPress",
            value: function detectTabKeyPress(event) {
                var key = event.which;
                if (key === KEY_TAB) {
                    document.body.classList.add("show-focus-outlines");
                }
            }
        },
        {
            /**
     * Detect mouse click and set it in the state and removes a class from the body
     * to hide focus highlighting
     * @param event {Object}
     */ key: "detectClick",
            value: function detectClick() {
                document.body.classList.remove("show-focus-outlines");
            }
        },
        {
            /**
     * Opens or closes video container on scroll event according to wheel delta,
     * but without checking scroll position
     * @param event
     */ key: "handleScroll",
            value: function handleScroll(event) {
                var videoPlayer = this.props.state.videoPlayer;
                if (videoPlayer.video.source) {
                    if (event.deltaY < 0 && !videoPlayer.isOpen) {
                        this.props.toggleVideoPlayerState({
                            isOpen: true,
                            isPlaying: true
                        });
                    } else if (event.deltaY > 0 && videoPlayer.isOpen && !videoPlayer.video.isFullscreen) {
                        this.closePlayer();
                    }
                }
            }
        },
        {
            /**
     * Opens or closes video container on scroll event according to wheel delta
     * @param event
     */ key: "handleWheelRouter",
            value: function handleWheelRouter(event) {
                var videoPlayer = this.props.state.videoPlayer;
                // [REDACTED] WHOEVER WROTE THIS
                // This was causing the whole app to re-render on every scroll event
                // DO NOT REMOVE THE this.state.isCategoriesFilterOpen check
                // Ideally remove this horrible function
                if (window.innerWidth <= TABLET_TYPE_PX && this.state.isCategoriesFilterOpen) {
                    this.setState({
                        isCategoriesFilterOpen: false
                    });
                }
                if (videoPlayer.video.source) {
                    if (event.deltaY < 0 && !videoPlayer.isOpen) {
                        this.openPlayer(event);
                    } else if (event.deltaY > 0 && videoPlayer.isOpen && !videoPlayer.video.isFullscreen) {
                        this.closePlayer();
                    }
                }
            }
        },
        {
            /**
     * Sets a flag if a menu is opened
     * @param isMenuOpen {Boolean}
     */ key: "setMenuFlag",
            value: function setMenuFlag(isMenuOpen) {
                this.isMenuOpened = isMenuOpen;
            }
        },
        {
            /**
     * Opens or closes video container on touch event according to swipe direction
     * @param event
     * @param direction {string}
     */ key: "handleSwipe",
            value: function handleSwipe(event, direction) {
                var videoPlayer = this.props.state.videoPlayer;
                if (videoPlayer.video.source) {
                    if (direction === DIRECTION_DOWN && !videoPlayer.isOpen) {
                        this.openPlayer(event);
                    } else if (direction === DIRECTION_UP && videoPlayer.isOpen && !videoPlayer.video.isFullscreen) {
                        this.closePlayer();
                    }
                }
            }
        },
        {
            /**
     * Opens player container
     */ key: "openPlayer",
            value: function openPlayer() {
                if (this.routerContainer && this.routerContainer.scrollTop === 0) {
                    this.props.toggleVideoPlayerState({
                        isOpen: true,
                        isPlaying: true
                    });
                }
            }
        },
        {
            /**
     * Closes player container
     */ key: "closePlayer",
            value: function closePlayer() {
                if (!isMobile.any()) {
                    this.props.toggleHeader(false);
                    this.props.toggleVideoPlayerState({
                        isOpen: false,
                        isPlaying: true
                    });
                }
            }
        },
        {
            key: "handleWindowResize",
            value: function handleWindowResize() {
                var clientWidth = document.body.clientWidth;
                var screenType = this.props.state.screenType;
                var isScreenLandscape = window.matchMedia("(orientation: landscape)").matches;
                var newScreenType = {
                    web: clientWidth > TABLET_TYPE_PX,
                    tablet: clientWidth >= MOBILE_TYPE_PX && clientWidth <= TABLET_TYPE_PX,
                    mobile: clientWidth < MOBILE_TYPE_PX,
                    smallMobile: clientWidth <= SMALL_MOBILE_TYPE_PX,
                    isLandscape: isScreenLandscape
                };
                var isMobileOnLandscape = (newScreenType.tablet || newScreenType.mobile) && newScreenType.isLandscape && isMobile.any();
                this.setState(function() {
                    return {
                        isScreenLandscape: isScreenLandscape,
                        isMobileOnLandscape: isMobileOnLandscape,
                        isCategoriesFilterOpen: false
                    };
                });
                if (!isEqual(newScreenType, screenType)) {
                    this.props.changeScreenType(newScreenType);
                    var action1 = newScreenType.mobile ? "add" : "remove";
                    document.getElementById("body").classList[action1]("mobile-device");
                }
            }
        },
        {
            /**
     * Close cookie consent banner
     */ key: "closeCookieBanner",
            value: function closeCookieBanner() {
                this.setState({
                    shouldShowCookieBanner: false
                });
            }
        },
        {
            /**
     * Call the getLiveChannels request and set a time stamp
     * because channel thumbnail urls stay the same thus not triggering
     * rerender of the thumbnails
     */ key: "getLiveChannels",
            value: function getLiveChannels() {
                this.props.getLiveChannels();
                this.setState({
                    liveChannelsTimeStamp: new Date().getTime()
                });
            }
        },
        {
            key: "renderHeader",
            value: function renderHeader() {
                var _this = this;
                var _this_state = this.state, isScreenLandscape = _this_state.isScreenLandscape, isCategoriesFilterOpen = _this_state.isCategoriesFilterOpen;
                var _this_props_state = this.props.state, screenType = _this_props_state.screenType, serverTime = _this_props_state.serverTime, authentication = _this_props_state.authentication;
                return /*#__PURE__*/ _jsx("div", {
                    ref: function(el) {
                        _this.header = el;
                    },
                    children: authentication.token ? /*#__PURE__*/ _jsx(Header, {
                        setMenuFlag: this.setMenuFlag,
                        isScreenLandscape: isScreenLandscape,
                        screenType: screenType,
                        getLiveChannels: this.getLiveChannels,
                        serverTime: serverTime,
                        isCategoriesFilterOpen: isCategoriesFilterOpen,
                        closeCategoryFilter: this.closeCategoryFilter,
                        toggleCategoryFilter: this.toggleCategoryFilter
                    }) : null
                });
            }
        },
        {
            /**
     * Changes the state of the alphabetical filter
     * @param {Boolean} filterState
     */ key: "onAlphabeticalFilterChange",
            value: function onAlphabeticalFilterChange(filterState) {
                this.setState({
                    isAlphabeticalFilterChecked: filterState
                });
            }
        },
        {
            key: "onAppBannerChange",
            value: function onAppBannerChange(appBannerState) {
                this.setState({
                    appBannerState: appBannerState
                });
            }
        },
        {
            key: "renderPlayer",
            value: function renderPlayer() {
                var _this = this;
                var _this_state = this.state, isScreenLandscape = _this_state.isScreenLandscape, isMobileOnLandscape = _this_state.isMobileOnLandscape, isMenuOpened = _this_state.isMenuOpened, showCommonElements = _this_state.showCommonElements;
                var authentication = this.props.state.authentication;
                return /*#__PURE__*/ _jsx("div", {
                    ref: function(el) {
                        _this.player = el;
                    },
                    children: authentication.token && showCommonElements ? /*#__PURE__*/ _jsx(PlayerWrapper, {
                        closePlayer: this.closePlayer,
                        openPlayer: this.openPlayer,
                        header: this.header,
                        isMenuOpened: isMenuOpened,
                        routerContainer: this.routerContainer,
                        isScreenLandscape: isScreenLandscape,
                        isMobileOnLandscape: isMobileOnLandscape
                    }) : null
                });
            }
        },
        {
            key: "snackbarAction",
            value: function snackbarAction(key) {
                var _this = this;
                return /*#__PURE__*/ _jsx("span", {
                    onClick: function() {
                        return _this.snackbar.closeSnackbar(key);
                    },
                    onKeyDown: function() {
                        return _this.snackbar.closeSnackbar(key);
                    },
                    className: "icon icon-clear"
                }, new Date().getTime());
            }
        },
        {
            key: "setPostLoginModalOpened",
            value: function setPostLoginModalOpened(value) {
                this.setState({
                    postLoginModalOpened: value
                });
            }
        },
        {
            key: "renderMissingInfo",
            value: function renderMissingInfo() {
                if (this.state.postLoginModalOpened) return null;
                var _this_props_state = this.props.state, userDetails = _this_props_state.userDetails, i18n = _this_props_state.i18n, order = _this_props_state.order, authentication = _this_props_state.authentication;
                this.setPostLoginModalOpened(true);
                var forceShow = this.state.forceShowMissingInfo;
                this.props.openModal(MISSING_INFO, {
                    setPostLoginModalOpened: this.setPostLoginModalOpened,
                    forceShow: forceShow
                });
                this.setState({
                    forceShowMissingInfo: false
                });
            }
        },
        {
            key: "renderMessagePopup",
            value: function renderMessagePopup() {
                if (this.state.postLoginModalOpened) return null;
                var userMessages = this.props.state.userMessages;
                this.setPostLoginModalOpened(true);
                this.props.openModal(MESSAGE_MODULE, {
                    messages: userMessages.urgent,
                    i18n: this.props.i18n,
                    screenType: this.props.state.screenType,
                    setPostLoginModalOpened: this.setPostLoginModalOpened
                });
            }
        },
        {
            key: "shouldRenderMissingInfo",
            value: function shouldRenderMissingInfo() {
                var _userMessages_urgent;
                var postponed = sessionStorage.getItem("missing-info");
                var _this_props_state = this.props.state, userDetails = _this_props_state.userDetails, userMessages = _this_props_state.userMessages;
                if (this.state.forceShowMissingInfo && !postponed) {
                    return true;
                }
                if (postponed || userDetails.cf_terms === false || ((_userMessages_urgent = userMessages.urgent) === null || _userMessages_urgent === void 0 ? void 0 : _userMessages_urgent.length) || isEmpty(userMessages)) {
                    return false;
                }
                return userDetails.cf_req_billing || userDetails.cf_req_password || userDetails.cf_req_payment;
            }
        },
        {
            key: "shouldRenderMessage",
            value: function shouldRenderMessage() {
                var _userMessages_urgent;
                var _this_props_state = this.props.state, userDetails = _this_props_state.userDetails, userMessages = _this_props_state.userMessages;
                if (isEmpty(userDetails)) return false;
                return (userMessages === null || userMessages === void 0 ? void 0 : (_userMessages_urgent = userMessages.urgent) === null || _userMessages_urgent === void 0 ? void 0 : _userMessages_urgent.length) > 0 && userDetails.cf_terms !== false;
            }
        },
        {
            key: "shouldRenderGuide",
            value: function shouldRenderGuide() {
                var _this_props_state = this.props.state, userDetails = _this_props_state.userDetails, userMessages = _this_props_state.userMessages;
                if (isEmpty(userDetails) || isEmpty(userMessages)) return false;
                var cf_guide = userDetails.cf_guide, cf_terms = userDetails.cf_terms;
                return Boolean(cf_guide) && cf_terms !== false;
            }
        },
        {
            key: "renderGuide",
            value: function renderGuide() {
                if (this.state.postLoginModalOpened) return null;
                var _this_props_state = this.props.state, userDetails = _this_props_state.userDetails, userMessages = _this_props_state.userMessages;
                var cf_guide = userDetails.cf_guide;
                this.setPostLoginModalOpened(true);
                this.props.openModal(INSTALLATION_GUIDE, {
                    setPostLoginModalOpened: this.setPostLoginModalOpened,
                    isModal: true,
                    subroute: cf_guide
                });
            }
        },
        {
            key: "getQueryParam",
            value: function getQueryParam(param) {
                var searchParams = new URLSearchParams(this.props.location.search);
                return searchParams.get(param);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _userMessages_urgent;
                var template = null;
                var _this_props_state = this.props.state, authentication = _this_props_state.authentication, i18n = _this_props_state.i18n, videoPlayer = _this_props_state.videoPlayer, modal = _this_props_state.modal, serverTime = _this_props_state.serverTime, userDetails = _this_props_state.userDetails, userMessages = _this_props_state.userMessages;
                var _this_state = this.state, liveChannelsTimeStamp = _this_state.liveChannelsTimeStamp, isAlphabeticalFilterChecked = _this_state.isAlphabeticalFilterChecked, isCategoriesFilterOpen = _this_state.isCategoriesFilterOpen, appBannerState = _this_state.appBannerState;
                var path = this.props.location.pathname;
                var additionalClasses = "";
                if (path.search(ROUTE_ORDER) >= 0) {
                    var hasFooter = path.search(ROUTE_ORDER_SUBSCRIPTIONS) >= 0 || path.search(ROUTE_ORDER_PREVIEW) >= 0 || path.search(ROUTE_ORDER_ADDRESSES) >= 0;
                // additionalClasses = hasFooter ? ' with-footer' : ' without-footer';
                } else if (path.search(ROUTE_SEARCH) >= 0) {
                    additionalClasses = " search";
                }
                additionalClasses += path.search(ROUTE_SEARCH) >= 0 ? " header-big" : "";
                additionalClasses += videoPlayer.isPlaying ? " video-playing" : "";
                additionalClasses += authentication.token ? "" : " no-auth";
                additionalClasses += path.search(ROUTE_ORDER) >= 0 ? " order" : "";
                // TODO: This is absurd to do for every component that adds things to the header ...
                // Page is not set up properly
                additionalClasses += (appBannerState === null || appBannerState === void 0 ? void 0 : appBannerState.open) ? " with-app-banner ".concat(appBannerState === null || appBannerState === void 0 ? void 0 : appBannerState.deviceType) : "";
                var hasOtherModals = this.shouldRenderMissingInfo() || isEmpty(userMessages) || (userMessages === null || userMessages === void 0 ? void 0 : (_userMessages_urgent = userMessages.urgent) === null || _userMessages_urgent === void 0 ? void 0 : _userMessages_urgent.length) !== 0 || (userDetails === null || userDetails === void 0 ? void 0 : userDetails.cf_terms) === false;
                var isPromotionsHidden = modal.isPromotionsOpened && modal.isModalOpened && modal.modalName === COOKIE_POLICY || hasOtherModals || this.state.postLoginModalOpened;
                if (isEmpty(i18n) || serverTime === null) {
                    template = null;
                } else {
                    var _this_props_state_userDetails;
                    var playerAndHeaderContainerClass = authentication.token ? " logged" : "";
                    template = /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            modal.isModalOpened && /*#__PURE__*/ _jsx(ModalConductor, {
                                modalData: modal
                            }),
                            modal.isWriteToUsOpened && /*#__PURE__*/ _jsx(WriteToUs, {}),
                            modal.isGdprOpened && /*#__PURE__*/ _jsx(Gdpr, {}),
                            modal.isConfirmationOpened && /*#__PURE__*/ _jsx(Confirmation, {}),
                            modal.isPromotionsOpened && (userDetails === null || userDetails === void 0 ? void 0 : userDetails.cf_terms) !== false && !isPromotionsHidden && /*#__PURE__*/ _jsx(Promotions, {
                                isHidden: isPromotionsHidden,
                                i18n: i18n,
                                closePromotions: this.props.closePromotions,
                                planDetails: (_this_props_state_userDetails = this.props.state.userDetails) === null || _this_props_state_userDetails === void 0 ? void 0 : _this_props_state_userDetails.planDetails,
                                prismicPlan: modal.prismicPlan
                            }),
                            modal.isPinModalOpened && /*#__PURE__*/ _jsx(PinModal, _object_spread({}, modal.pinModalProps)),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "player-and-header-container".concat(playerAndHeaderContainerClass),
                                children: [
                                    this.renderPlayer(),
                                    this.renderHeader()
                                ]
                            }),
                            /*#__PURE__*/ _jsx(DownloadAppBanner, {
                                darkBackground: !authentication.token,
                                onBannerChange: this.onAppBannerChange
                            }),
                            this.showNotification(),
                            /*#__PURE__*/ _jsx("div", {
                                ref: function(el) {
                                    _this.routerContainer = el;
                                },
                                className: "router-container".concat(additionalClasses),
                                children: /*#__PURE__*/ _jsxs(Suspense, {
                                    fallback: null,
                                    children: [
                                        /*#__PURE__*/ _jsx(ScrollToTop, {}),
                                        /*#__PURE__*/ _jsxs(Switch, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/",
                                                    render: function() {
                                                        return /*#__PURE__*/ _jsx(Redirect, {
                                                            to: DEFAULT_LOGGED_ROUTE
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: ROUTE_LIVE,
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(Live, _object_spread_props(_object_spread({}, omit(props, [
                                                            "match"
                                                        ])), {
                                                            videoPlayer: videoPlayer,
                                                            i18n: i18n,
                                                            getLiveChannels: _this.getLiveChannels,
                                                            isAlphabeticalFilterChecked: isAlphabeticalFilterChecked,
                                                            closePlayer: _this.closePlayer,
                                                            liveChannelsTimeStamp: liveChannelsTimeStamp,
                                                            onAlphabeticalFilterChange: _this.onAlphabeticalFilterChange,
                                                            serverTime: serverTime,
                                                            isCategoriesFilterOpen: isCategoriesFilterOpen,
                                                            closeCategoryFilter: _this.closeCategoryFilter,
                                                            toggleCategoryFilter: _this.toggleCategoryFilter
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: ROUTE_CATEGORY,
                                                    render: function() {
                                                        return /*#__PURE__*/ _jsx(Redirect, {
                                                            to: ROUTE_LIVE
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "".concat(MOST_WATCHED, "/last"),
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(LastWatchedCategories, _object_spread_props(_object_spread({}, omit(props, [
                                                            "match"
                                                        ])), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "".concat(MOST_WATCHED, "/last/category/:category"),
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(LastWatchedSubcategories, _object_spread_props(_object_spread({}, props), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "".concat(MOST_WATCHED, "/last/category/:category/listing"),
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(LastWatchedCategoryListing, _object_spread_props(_object_spread({}, props), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "".concat(MOST_WATCHED, "/last/category/:category/subcategory/:subcategory/listing"),
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(LastWatchedSubcategoryListing, _object_spread_props(_object_spread({}, props), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: MOST_WATCHED,
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(MostWatchedCategories, _object_spread_props(_object_spread({}, omit(props, [
                                                            "match"
                                                        ])), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "".concat(MOST_WATCHED, "/category/:category"),
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(MostWatchedSubcategories, _object_spread_props(_object_spread({}, props), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "".concat(MOST_WATCHED, "/category/:category/listing"),
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(MostWatchedCategoryListing, _object_spread_props(_object_spread({}, props), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "".concat(MOST_WATCHED, "/category/:category/subcategory/:subcategory/listing"),
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(MostWatchedSubcategoryListing, _object_spread_props(_object_spread({}, props), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: ROUTE_ON_RECORD,
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(OnRecordCategories, _object_spread_props(_object_spread({}, omit(props, [
                                                            "match"
                                                        ])), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "".concat(ROUTE_ON_RECORD, "/category/:category"),
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(OnRecordSubcategories, _object_spread_props(_object_spread({}, props), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "".concat(ROUTE_ON_RECORD, "/category/:category/listing"),
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(OnRecordCategoryListing, _object_spread_props(_object_spread({}, props), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "".concat(ROUTE_ON_RECORD, "/category/:category/subcategory/:subcategory/listing"),
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(OnRecordSubcategoryListing, _object_spread_props(_object_spread({}, props), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: VOD,
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(VODCategories, _object_spread_props(_object_spread({}, omit(props, [
                                                            "match"
                                                        ])), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "".concat(VOD, "/category/:category"),
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(VODSubcategories, _object_spread_props(_object_spread({}, props), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "".concat(VOD, "/category/:category/listing"),
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(VODCategoryListing, _object_spread_props(_object_spread({}, props), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "".concat(VOD, "/category/:category/subcategory/:subcategory/listing"),
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(VODSubcategoryListing, _object_spread_props(_object_spread({}, props), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/channel/:channel",
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(ChannelHistory, _object_spread_props(_object_spread({}, props), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/channel/:channel/listing/:date",
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(ChannelListingForDate, _object_spread_props(_object_spread({}, props), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/login",
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(SignInPage, _object_spread_props(_object_spread({}, omit(props, [
                                                            "match"
                                                        ])), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/register",
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(SignUpPage, _object_spread_props(_object_spread({}, omit(props, [
                                                            "match"
                                                        ])), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/forgotten-password",
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(ForgottenPasswordRequestPage, _object_spread_props(_object_spread({}, omit(props, [
                                                            "match"
                                                        ])), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/reset-password",
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(ResetPasswordPage, _object_spread_props(_object_spread({}, omit(props, [
                                                            "match"
                                                        ])), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/restricted-geography",
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(RestrictedGeography, _object_spread_props(_object_spread({}, omit(props, [
                                                            "match"
                                                        ])), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/restricted-access",
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(TooManyUsers, _object_spread_props(_object_spread({}, omit(props, [
                                                            "match"
                                                        ])), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/search",
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(SearchPage, _object_spread_props(_object_spread({}, omit(props, [
                                                            "match"
                                                        ])), {
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/order",
                                                    render: function() {
                                                        return /*#__PURE__*/ _jsx(Redirect, {
                                                            to: "/order/subscriptions"
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/order/:step",
                                                    render: function(props) {
                                                        return /*#__PURE__*/ _jsx(Order, _object_spread_props(_object_spread({}, props), {
                                                            getLiveChannels: _this.getLiveChannels,
                                                            i18n: i18n
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: ROUTE_ACCOUNT_DELETE,
                                                    render: function() {
                                                        return /*#__PURE__*/ _jsx(DeleteAccountPage, {
                                                            isLoginForm: !DELETE_ACCOUNT_IS_FORM
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/404",
                                                    render: function() {
                                                        return /*#__PURE__*/ _jsx(NoMatch, {
                                                            i18n: i18n
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/terms-of-use",
                                                    render: function() {
                                                        return /*#__PURE__*/ _jsx(TermsAndConditionsPage, {
                                                            userDetails: _this.props.state.userDetails,
                                                            authentication: _this.props.state.authentication,
                                                            history: _this.props.history
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/privacy-policy",
                                                    render: function() {
                                                        return /*#__PURE__*/ _jsx(PrivaciPolicyPage, {});
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/guide",
                                                    render: function() {
                                                        return /*#__PURE__*/ _jsx(GuidePage, {});
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Route, {
                                                    exact: true,
                                                    path: "/guide/:category",
                                                    render: function() {
                                                        return /*#__PURE__*/ _jsx(GuidePage, {});
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Redirect, {
                                                    to: "/404"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                }
                return /*#__PURE__*/ _jsx(SnackbarProvider, {
                    maxSnack: 2,
                    onEntered: this.props.openSnackbar,
                    className: "snackbar",
                    autoHideDuration: null,
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    },
                    onClose: this.props.closeSnackbar,
                    action: this.snackbarAction,
                    ref: function(el) {
                        _this.snackbar = el;
                    },
                    children: template
                });
            }
        }
    ]);
    return App;
}(Component);
var mapStateToProps = function(state) {
    return {
        state: state
    };
};
//  Promote App from a component to a container - it needs to know
// about this new dispatch method, getTranslations. Make it available as a prop.
export default withRouter(connect(mapStateToProps, {
    getTranslations: getTranslations,
    getLogos: getLogos,
    setLastRequestedRoute: setLastRequestedRoute,
    toggleVideoPlayerState: toggleVideoPlayerState,
    getProfileSettings: getProfileSettings,
    changeScreenType: changeScreenType,
    getUserDetails: getUserDetails,
    getFullUserDetails: getFullUserDetails,
    getLiveChannels: getLiveChannels,
    getLiveCategories: getLiveCategories,
    toggleHeader: toggleHeader,
    getServerTime: getServerTime,
    openModal: openModal,
    closeModal: closeModal,
    setVideoToPlayAfterSubscription: setVideoToPlayAfterSubscription,
    openPromotions: openPromotions,
    closeSnackbar: closeSnackbar,
    openSnackbar: openSnackbar,
    closeGdpr: closeGdpr,
    closePromotions: closePromotions,
    closeWriteToUs: closeWriteToUs,
    setLiveChannelsLayout: setLiveChannelsLayout,
    getAppConfig: getAppConfig,
    prismicGetSubscriptions: prismicGetSubscriptions,
    getUserMessages: getUserMessages,
    setAuthToken: setAuthToken
})(App));
